import JWT from "../../../api/jwt";
import Vue from "vue";

const STORE_ME = (state, messages) => {
  state.me = messages;
  Vue.buildCan(state.me);
  state.authenticated = true;
};

const STORE_ME_IN_GFS = (state, meInGfs) => {
  state.meInGfs = meInGfs;
};

const STORE_ME_TOKEN = (state, data) => {
  state.me = data.user;
  Vue.buildCan(state.me);
  state.authenticated = !data.user.password_reset;
  JWT.saveToken(data.token);
};

const DELETE_ME_AUTHENTICATED = state => {
  state.me = [];
  state.meInGfs = [];
  state.notifications = [];
  state.authenticated = false;
  JWT.destroyToken();
};

const STORE_NOTIFICATIONS = (state, notifications) => {
  state.notifications = notifications;
};

export default {
  STORE_ME_IN_GFS,
  STORE_ME,
  STORE_ME_TOKEN,
  DELETE_ME_AUTHENTICATED,
  STORE_NOTIFICATIONS
};
